import toastr from 'toastr'

// Setting toastr as a global variable only for the sake of feature specs
window.toastr = toastr

toastr.options = {
  closeButton: true,
  newestOnTop: true,
  progressBar: false,
  positionClass: 'toast-top-center',
  onclick: null,
  showDuration: '400',
  hideDuration: '1200',
  timeOut: '7000',
  extendedTimeOut: '5000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
  toastClass: 'toastr'
}

$(document).on('turbo:before-cache', function () {
  // toastr.clear()
})

export default toastr
